export enum SalesReportGraphBucket {
  Day = 'day',
  Month = 'month',
  Week = 'week',
}
